import axios from 'axios'
import {
  Message
} from 'element-ui'
import router from '../router/index'

// 创建axios实例对象
// https://wx.zazakitart.com
const service = axios.create({
  baseURL: "https://wx.zazakitart.com",
  timeout: 10000,
  headers: {
    post: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
  emulateJSON: true,
  // withCredentials: true
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 每个请求接口的公共参数
    if (window.localStorage.getItem("token")) {
      config.headers.Authorization = `Bearer ${window.localStorage.getItem('token')}`;
    }
    return config;
  },
  error => {
    console.log(error)
    return Promise.reject(error);
  })

// 响应拦截器
service.interceptors.response.use(
  res => {
    if (res.status == 200) {
      if (res.data.code == 0) {
        return res.data;
      } else {
        Message.error(res.data.message);
        return Promise.reject(error)
      }
    } else {
      Message.error("网络错误,请检查网络或者联系管理员");
    }

    // // 成功响应数据
    // if (res.data.code === 200) return res.data;

    // else {
    //   Message.error(res.data.message);
    //   return Promise.reject(res.data)
    // }
  },
  error => {
    // 响应错误提示
    console.log(error)
   Message.error("网络错误,请检查网络或者联系管理员");
    // if (error.response.status == 401) {
    //   this.$router.push({ path: '/login' })
    // }
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js